import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Award } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const STATUS_COLORS = {
  pending: 'text-[#D4AF37] bg-[#D4AF37]/10',
  approved: 'text-emerald-400 bg-emerald-500/10',
  paid: 'text-green-500 bg-green-500/10',
};

const VipReferrals = () => {
  const [bonuses, setBonuses] = useState([]);

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      const { data } = await axios.get(`${API}/vip/dashboard`, { withCredentials: true });
      setBonuses(data.bonuses || []);
    } catch (err) { console.error(err); }
  };

  return (
    <div data-testid="vip-referrals-page" className="space-y-6">
      <div>
        <h2 className="font-['Outfit'] text-3xl font-bold text-white mb-2">Referral History</h2>
        <p className="text-[#A3A3A3]">Track every invoice your code has helped close.</p>
      </div>

      <div className="bg-[#141414] border border-[#262626] rounded-md overflow-hidden">
        <table className="w-full">
          <thead className="bg-[#0A0A0A] border-b border-[#262626]">
            <tr>
              <th className="text-left px-6 py-3 text-[#A3A3A3] text-xs uppercase tracking-wider">Customer</th>
              <th className="text-left px-6 py-3 text-[#A3A3A3] text-xs uppercase tracking-wider">Invoice</th>
              <th className="text-right px-6 py-3 text-[#A3A3A3] text-xs uppercase tracking-wider">Final Paid</th>
              <th className="text-right px-6 py-3 text-[#A3A3A3] text-xs uppercase tracking-wider">Bonus</th>
              <th className="text-center px-6 py-3 text-[#A3A3A3] text-xs uppercase tracking-wider">Status</th>
              <th className="text-left px-6 py-3 text-[#A3A3A3] text-xs uppercase tracking-wider">Date</th>
            </tr>
          </thead>
          <tbody>
            {bonuses.length === 0 ? (
              <tr><td colSpan={6} className="text-center px-6 py-12 text-[#A3A3A3]">
                <Award className="w-8 h-8 mx-auto mb-2 text-[#262626]" />
                No referrals yet. Share your promo code to start earning.
              </td></tr>
            ) : bonuses.map((b) => (
              <tr key={b.id} data-testid={`vip-bonus-row-${b.id}`} className="border-b border-[#262626] last:border-0 hover:bg-[#0A0A0A]">
                <td className="px-6 py-4 text-white">{b.customer_name}</td>
                <td className="px-6 py-4 text-[#A3A3A3] font-mono text-sm">{b.invoice_number || '—'}</td>
                <td className="px-6 py-4 text-right text-white">${(b.final_paid || 0).toFixed(2)}</td>
                <td className="px-6 py-4 text-right text-[#D4AF37] font-bold">${(b.bonus_amount || 0).toFixed(2)}</td>
                <td className="px-6 py-4 text-center">
                  <span className={`px-2 py-1 rounded text-xs font-medium ${STATUS_COLORS[b.status] || 'text-[#A3A3A3] bg-[#262626]'}`}>{(b.status || 'pending').toUpperCase()}</span>
                </td>
                <td className="px-6 py-4 text-[#A3A3A3] text-sm">{b.created_at ? new Date(b.created_at).toLocaleDateString() : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VipReferrals;
